type ErrorPayload = {
  message: string;
  stack?: string;
  url?: string;
  level?: 'error' | 'warning' | 'info';
  metadata?: Record<string, unknown>;
};

let lastReportedAt = 0;
const MIN_INTERVAL_MS = 1000;

export async function reportError(p: ErrorPayload): Promise<void> {
  const now = Date.now();
  if (now - lastReportedAt < MIN_INTERVAL_MS) return;
  lastReportedAt = now;
  try {
    await fetch('/api/_internal/errors', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        message: p.message,
        stack: p.stack,
        url: p.url || location.href,
        userAgent: navigator.userAgent,
        level: p.level,
        metadata: p.metadata,
      }),
      keepalive: true,
    });
  } catch {
    // suppress — error-reporting failures must not surface to the user
  }
}

export function installGlobalErrorHandlers(): void {
  window.addEventListener('error', (e) => {
    reportError({
      message: e.message || 'window.onerror',
      stack: e.error?.stack,
      url: location.href,
      metadata: { filename: e.filename, lineno: e.lineno, colno: e.colno },
    });
  });

  window.addEventListener('unhandledrejection', (e) => {
    const reason = e.reason;
    reportError({
      message: reason?.message || String(reason || 'unhandledrejection'),
      stack: reason?.stack,
      url: location.href,
      metadata: { kind: 'unhandledrejection' },
    });
  });
}
